import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Search from './pages/Search';
import AnnonceDetail from './pages/AnnonceDetail';
import Auth from './pages/Auth';
import TextesDeLoi from './pages/TextesDeLoi';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Auth routes - full page without Navbar/Footer */}
        <Route path="/connexion" element={<Auth />} />
        <Route path="/inscription" element={<Auth />} />
        <Route path="/mot-de-passe-oublie" element={<Auth />} />
        <Route path="/verification-otp/:type?" element={<Auth />} />

        {/* Main layout routes with Navbar/Footer */}
        <Route
          path="*"
          element={
            <div className="app">
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/recherche" element={<Search />} />
                  <Route path="/annonce/:id" element={<AnnonceDetail />} />
                  <Route path="/textes-de-loi" element={<TextesDeLoi />} />
                  <Route path="/aide" element={<div style={{padding:'80px 20px', textAlign:'center'}}><h1>Aide</h1><p>Page d'aide à venir.</p></div>} />
                </Routes>
              </main>
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
